import ValidationErrorResponse from "interfaces/server/ValidationErrorResponse";

export function isErrorValidationErrorResponse(error: any): error is ValidationErrorResponse {
  if (error.title !== undefined
    && error.type !== undefined
    && error.status !== undefined
    && error.errors !== undefined) {
    return true;
  }
  return false;
}

export function reduceValidationErrors(error: ValidationErrorResponse, separator: string = ' '): string {
  return Object.keys(error.errors)
    .flatMap(k => error.errors[k])
    .join(separator);
}

export function getResponseErrorMessage(err: any) {
  if (isErrorValidationErrorResponse(err)) {
    return reduceValidationErrors(err);
  } else if (err.message) {
    return err.message;
  } else {
    return err.toString();
  }
}